import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { afterItems, beforeItems, transformationStats } from '../data/transformation';
export function TransformationSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-28" data-id="element-166" data-mp="2ww2p8roo2zvm">
      <Reveal className="mx-auto max-w-5xl" data-id="element-167" data-mp="2rz2isfnwnv3z">
        <div className="mx-auto max-w-3xl text-center" data-id="element-168" data-mp="2ryayw23o7ltj">
          <p className="mb-4 text-xs font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-169" data-mp="2nx7h3a22bfpo">
            UN MODO MIGLIORE DI INSEGNARE MATEMATICA
          </p>
          <h2 className="text-4xl font-black leading-[1.08] tracking-tight text-brand-blue md:text-5xl" data-id="element-170" data-mp="2j462l35rpi6m">
            Da insegnante travolto dalle preparazioni a{' '}
            <span className="italic text-brand-purple" data-id="element-171" data-mp="299dzxkxbw54z">guida sicura in classe.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-brand-gray md:text-base" data-id="element-172" data-mp="247or8bxkw3k2">
            Ogni insegnante di matematica conosce la sensazione: cercare schede sparse in rete, rispiegare gli stessi
            passaggi, chiedersi se la classe arriverà davvero in fondo al programma. Matematica Pronta toglie di mezzo
            tutto questo e ti lascia solo la parte che conta: insegnare.
          </p>
        </div>
        <div className="mx-auto my-12 grid max-w-3xl divide-y divide-brand-dark overflow-hidden rounded-2xl border border-brand-dark bg-brand-alt shadow-sm sm:grid-cols-3 sm:divide-x sm:divide-y-0" data-id="element-173" data-mp="5b1x9cje6z5r">
          {transformationStats.map(([value, label]) => <div key={label} className="px-5 py-5 text-center" data-id="element-174" data-mp="12zc2s1ie051m">
              <strong className="block font-serif text-3xl leading-none text-brand-orange" data-id="element-175" data-mp="p1f0qpl5z6fk">{value}</strong>
              <span className="mt-2 block text-[10px] font-extrabold leading-tight tracking-[0.08em] text-brand-gray" data-id="element-176" data-mp="t1pit0m8dnas">
                {label}
              </span>
            </div>)}
        </div>
        <div className="overflow-hidden rounded-3xl border border-brand-dark bg-brand-alt shadow-[0_18px_45px_rgba(27,42,91,0.10)]" data-id="element-177" data-mp="3dsybkxl4b823">
          <div className="grid md:grid-cols-2" data-id="element-178" data-mp="1k97iszgmtjx8">
            <Comparison title="PRIMA" items={beforeItems} positive={false} data-id="element-179" data-mp="1facrf94lmn1i" />
            <Comparison title="CON MATEMATICA PRONTA" items={afterItems} positive data-id="element-180" data-mp="1ak655fxk7emf" />
          </div>
          <div className="border-t border-brand-dark bg-brand-main px-6 py-4 text-center text-xs font-semibold text-brand-gray" data-id="element-181" data-mp="15l2yjr1xl0cc">
            Un programma di matematica completo che ti prepara la lezione al posto tuo e ti fa entrare in classe
            tranquillo.
          </div>
        </div>
      </Reveal>
    </section>;
}
function Comparison({
  title,
  items,
  positive
}: {
  title: string;
  items: string[];
  positive: boolean;
}) {
  const Icon = positive ? CheckCircle2Icon : XCircleIcon;
  return <div className={`p-6 md:p-9 ${positive ? 'border-t border-brand-dark bg-brand-alt md:border-l md:border-t-0' : 'bg-[#f5f0e8]'}`} data-id="element-182" data-mp="2lzcm4iycml24">
      <div className="mb-7 flex items-start justify-between gap-4" data-id="element-183" data-mp="2h1jinxofk55j">
        <div data-id="element-184" data-mp="2phs95n929d0e">
          <p className={`text-[10px] font-extrabold tracking-[0.16em] ${positive ? 'text-brand-teal' : 'text-brand-gray'}`} data-id="element-185" data-mp="2pi1zxd1xjo75">
            {positive ? 'IL SISTEMA PRONTO ALL’USO' : 'IL VECCHIO MODO DI INSEGNARE MATEMATICA'}
          </p>
          <h3 className="mt-2 font-serif text-2xl font-bold tracking-tight text-brand-blue" data-id="element-186" data-mp="2ybwwvxswe8bp">{title}</h3>
        </div>
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-brand-teal text-white shadow-md' : 'bg-brand-alt text-brand-gray'}`} data-id="element-187" data-mp="26io3mogqa1dh">
          <Icon className="h-5 w-5" aria-hidden="true" data-id="element-188" data-mp="2fjchnj64g1qd" />
        </div>
      </div>
      <ul className="space-y-2.5" data-id="element-189" data-mp="2flffgpdimz5n">
        {items.map(item => <li key={item} className={`flex items-center gap-3 rounded-xl px-3 py-3 ${positive ? 'bg-brand-main' : 'bg-brand-alt/70'}`} data-id="element-190" data-mp="2kjqpb03t99nv">
            <Icon className={`h-4 w-4 shrink-0 ${positive ? 'text-brand-teal' : 'text-brand-gray'}`} aria-hidden="true" data-id="element-191" data-mp="3vwjf45d1jo1a" />
            <span className={`text-sm leading-snug ${positive ? 'font-semibold text-brand-text' : 'text-brand-gray'}`} data-id="element-192" data-mp="18qq0ocuxiad1">
              {item}
            </span>
          </li>)}
      </ul>
    </div>;
}